import { IEventAggregator } from 'common/barrels/core';
import { IResourceProvider } from 'common/resourceprovider';

import { ContainerControl } from 'runtime/controls/containercontrol';
import { IMethodRouter } from 'runtime/methodrouter';
import { IValueStore } from 'runtime/valuestore';

import { Serializer } from 'common/serializer';

// CLEAN UP
import { MockMethodRouter } from 'runtime/methodrouter';
import { emptyGuid } from 'common/functions/guid';
import { MockValueStore } from 'runtime/valuestore';
import * as $ from 'jquery';

export class ControlArgs {
    constructor(public element: Node, public config: any, public eventAggregator: IEventAggregator, public methods: IMethodRouter, public values: IValueStore,
                public fieldContext: string, public resources: IResourceProvider, public container: ContainerControl, public serializer: Serializer) { }

    // CLEAN UP
    static createMock($element: JQuery, config: any, eventAggregator: IEventAggregator, fieldContext: string, resources: IResourceProvider): ControlArgs {
        var defaultConfig = {
            elementName: null
        };

        $.extend(defaultConfig, config || {});

        return new ControlArgs($element[0], defaultConfig, eventAggregator, new MockMethodRouter(), new MockValueStore(), fieldContext || emptyGuid, resources, null, null);
    }
}
